module.exports = __webpack_public_path__ + "img/ricardo-gomez-angel-9AdeEdYB2yk-unsplash.903542a4.jpg";